import React, {FC} from 'react';

import {CircularLoader, Colors, Text, Title} from '@optimaxdev/design-system';
import {Icon} from '@optimaxdev/icons';

import {ButtonType, LinkType, popupLinkConstants} from '../constants';

type PropsType = {
    selectedPopup: ButtonType | LinkType;
    sendAnalytics: () => void;
    showPopup: () => void;
    isPopupLoading: boolean;
};

import s from './rateUsContentRedesign.scss';

/**
 * Rate us content
 */
export const RateUsContentRedesign: FC<PropsType> = ({
    isPopupLoading,
    selectedPopup,
    sendAnalytics,
    showPopup,
}) => {
    const renderButtonOrLink = () => (
        <>
            {Object.keys(popupLinkConstants).includes(selectedPopup.id) ? (
                <a
                    className={s.link}
                    href={(selectedPopup as LinkType).link}
                    onClick={sendAnalytics}
                    rel="noreferrer"
                    target="_blank"
                >
                    Rate Us
                </a>
            ) : (
                <button
                    onClick={() => {
                        showPopup();
                        sendAnalytics();
                    }}
                    className={s.btn}
                    type="button"
                >
                    {isPopupLoading ? <CircularLoader color={Colors.blueCharcoal} /> : 'Rate Us'}
                </button>
            )}
        </>
    );

    return (
        <section className={s.section}>
            <Title
                className={s.title}
                fontSize="24px"
                letterSpacing="normal"
                level={3}
                lineHeight="34px"
            >
                How did we do today?
            </Title>
            <Text color={Colors.limedSpruce} lineHeight="24px" margin="12px 0 0 0" size="16px">
                Let us know about your shopping experience with us.
            </Text>
            <div className={s.container}>
                {renderButtonOrLink()}
                <div className={s.iconContainer}>
                    <span className={s.via}>Via</span>
                    <Icon height={18} icon={selectedPopup.icon} />
                </div>
            </div>
        </section>
    );
};
